<template>
  <div class="nerd-results">
    <div class="row">
      <div class="col-6 col-xl-12">

        <table class="table">
          <tbody>
          <tr>
            <th>Accuracy Effective Level</th>
            <th>Accuracy Stance Bonus</th>
            <th>Damage Effective Level</th>
            <th>Max attack</th>
            <th>Max attack roll</th>
            <th>Weapon Accuracy Multiplier</th>
            <th>Weapon Damage Multiplier</th>
            <th>Max defence roll</th>
          </tr>
          <tr>
            <td>
              {{this.calcAccuracy.effectiveLevel()}}
            </td>
            <td>
              {{this.calcAccuracy.accuracyStanceBonus() + 8}}
            </td>

            <td>
              {{this.calcMaxHit.effectiveLevel()}}
            </td>
            <td>
              {{this.calcAccuracy.maxAttack()}}
            </td>
            <td>
              {{this.calcAccuracy.maxAttackRoll()}}
            </td>
            <td>
              {{this.calcAccuracy.weaponAccuracyMultiplier()}}
            </td>

            <td>
              {{this.calcMaxHit.weaponDamageMultiplier()}}
            </td>
            <td>
              {{this.calcAccuracy.maxDefenceRoll()}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>


      <div class="col-6 col-xl-12">
      </div>
    </div>
  </div>
</template>

<script>
  import {Potions} from "../js/potions.js"
  import {Damage} from "../js/damage";
  import {Accuracy} from "../js/accuracy";
  import {Player} from "../js/player";

  export default {
    name: "NerdResults",
    props: {
      monster: {
        type: Object,
      },
      setup: {
        type: Object,
      },
      player: {
        type: Object,
      }
    },
    data() {
      return {
        calcs: {
          monster: null,
          potion: null,
          maxhit: null,
          accuracy: null,
          player: null,
        },
      }
    },
    computed: {
      calcMaxHit: function () {
        return new Damage(this.player, this.setup, this.monster);
        // return this.calcs.maxhit;
      },
      calcAccuracy: function () {
        return new Accuracy(this.player, this.setup, this.monster);
        // return this.calcs.accuracy;
      },
      calcPotion: function () {
        return new Potions(this.player, this.setup);
        // return this.calcs.potion;
      },
      calcPlayer: function () {
        return new Player(this.player, this.setup);
      },

      weaponType: function () {
        return this.calcPlayer.activeWeaponType();
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NerdResults.vue